import React from 'react'

type Props = {
  open: boolean
  onClose: () => void
  pricePixe?: number | null
  onConfirm: () => Promise<void>
  busy?: boolean
  error?: string | null
}

export default function UnlockModal({ open, onClose, pricePixe, onConfirm, busy, error }: Props) {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <button className="absolute inset-0 bg-black/60" onClick={onClose} aria-label="Close" />
      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-neutral-950 p-5 shadow-xl">
        <div className="text-lg font-extrabold">Unlock this Pixe</div>
        <div className="mt-1 text-sm text-white/75">One-time unlock using your PIXE balance.</div>

        <div className="mt-4 rounded-xl border border-white/10 bg-white/5 p-4 flex items-center justify-between">
          <div className="text-sm text-white/70">Price</div>
          <div className="text-xl font-extrabold">{pricePixe ? `${pricePixe} PIXE` : 'PIXE'}</div>
        </div>

        {error ? <div className="mt-3 text-sm text-red-400">{error}</div> : null}

        <div className="mt-5 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-sm font-semibold hover:bg-white/10"
            disabled={Boolean(busy)}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded-xl bg-emerald-500 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-600 disabled:opacity-60"
            disabled={Boolean(busy) || !pricePixe}
          >
            {busy ? 'Unlocking…' : 'Unlock'}
          </button>
        </div>
      </div>
    </div>
  )
}

